import { useState } from "react";
import LinkedText from "@/components/protocol/LinkedText";
import { infoBoxConfig } from "@/config/constants";

const InfoBox = ({ type = "info", title, content, image, imageAlt }) => {
  const config = infoBoxConfig[type] || infoBoxConfig.info;
  const Icon = config.icon;
  const [imageExpanded, setImageExpanded] = useState(false);
  
  return (
    <div className={`rounded-lg border p-4 mb-4 ${config.className}`} data-testid={`info-box-${type}`}>
      <div className="flex gap-3">
        <Icon className={`w-5 h-5 shrink-0 mt-0.5 ${config.iconClass}`} />
        <div className="flex-1 min-w-0">
          {title && (
            <h4 className="font-semibold mb-1">{title}</h4>
          )}
          {content && (
            <div className="text-sm whitespace-pre-line">
              <LinkedText text={content} />
            </div>
          )}
          {image && (
            <div className="mt-3">
              <img 
                src={image} 
                alt={imageAlt || title || "Reference image"}
                className={`rounded-lg border border-border cursor-pointer transition-all duration-200 ${
                  imageExpanded ? 'w-full max-w-2xl' : 'max-h-48 w-auto'
                }`}
                onClick={() => setImageExpanded(!imageExpanded)}
              />
              <p className="text-xs text-muted-foreground mt-1">
                {imageExpanded ? 'Click to minimize' : 'Click to expand'}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InfoBox;
